import { withFinancialMetricsAccess } from "@crm-src/components/page-permission-guard"
import { useState, useEffect } from "react"
import { Box } from "@mui/material"
import { usePermissions } from "@crm-src/hooks/usePermissions"
import { financialApi } from "@crm-src/lib/api"
import { useToast } from "@crm-src/hooks/use-toast"
import { useSearchParams } from "react-router-dom";
import { PeriodType } from "@crm-src/types/financial-metrics"
import { ProductPerformanceTab } from "@crm-src/components/financial-metrics/product-performance-tab"

function ProductPerformancePage() {
  const [searchParams] = useSearchParams()
  const periodParam = searchParams.get('period') as PeriodType || '1M'
  
  const [period] = useState<PeriodType>(periodParam)
  const [productData, setProductData] = useState<any>(null)
  const [isLoadingProducts, setIsLoadingProducts] = useState(false)
  
  const { canAccessAdmin } = usePermissions()
  const { toast } = useToast()
  const isAdmin = canAccessAdmin()

  // Load product performance
  useEffect(() => {
    if (isAdmin) {
      loadProductPerformance()
    }
  }, [period, isAdmin])

  const loadProductPerformance = async () => {
    try {
      setIsLoadingProducts(true)
      const response = await financialApi.getProductPerformance({ period })
      setProductData(response.data)
    } catch (error: any) {
      console.error('Error loading product performance:', error)
      toast({
        title: "Error",
        description: error.response?.data?.error || "Failed to load product performance",
        variant: "destructive",
      })
    } finally {
      setIsLoadingProducts(false)
    }
  }

  if (!isAdmin) {
    return null
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3, mt: 3 }}>
      {productData && (
        <ProductPerformanceTab
          data={productData}
          isLoading={isLoadingProducts}
          period={period}
        />
      )}
    </Box>
  )
}

export default withFinancialMetricsAccess(ProductPerformancePage)



